import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/img/white-logo.png'


const _hoisted_1 = { class: "footer-part" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "this si company logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "All rights reserved.", -1)
const _hoisted_5 = { class: "list-unstyled right-side" }
const _hoisted_6 = ["href"]

import { socialLinks } from '@/data/socialLinks.json';

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createTextVNode("© " + _toDisplayString(new Date().getFullYear()) + " mY Plus Plus. ", 1),
        _hoisted_4
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialLinks), (socialLink) => {
        return (_openBlock(), _createElementBlock("li", {
          key: socialLink.id
        }, [
          _createElementVNode("a", {
            href: socialLink.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(`fa ${socialLink.icon}`)
            }, null, 2)
          ], 8, _hoisted_6)
        ]))
      }), 128))
    ])
  ]))
}
}

})